import type { FC, PropsWithChildren } from 'react'

import sanitizeHtml from 'sanitize-html'

import React from 'react'

import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import Typography from '@segment/matcha/components/Typography'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

export const paragraphs = [
  `In the complicated dance of business growth in 2023, it’s clear that AI is setting the rhythm but data will always choose the tune. Without rich, quality data to guide it, even the most sophisticated AI remains directionless.`,
  `As businesses continue to look for new (and sustainable) ways to find growth opportunities, making sure they have access to the best information to inform their campaigns (in whatever capacity) will be integral to that success.`,
  `Curious about how to get started in corralling, analyzing, and segmenting your own customer data to enhance your AI strategy while delivering better customer experiences?`,
  `A Customer Data Platform can help you with that.`,
]

const copy = {
  overline: `Our Take`,
  heading: `Data drives the ‘AI’-lgorithm of success`,
}

const OurTake: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper id="ourTake">
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <StyledCopyTextOverline tag="h2" variant="overline">
            {copy.overline}
          </StyledCopyTextOverline>
          <StyledDivider />
          <StyledCopyTextHeading>{copy.heading}</StyledCopyTextHeading>

          {paragraphs.map((item, index) => (
            <Typography
              variant="pSmall"
              key={index}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(item, { allowedTags: [`a`] }) }}
            />
          ))}
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding: 0;
    padding-bottom: 8px;
  }
`

const StyledCopyTextOverline = styled(CopyText.Overline)`
  text-transform: none;
  letter-spacing: 0;
`

const StyledDivider = styled(Divider)`
  margin: 25px 0 0;
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  padding-top: 16px;
`

export default OurTake
